<template>
  <div id="footerbar">
    <el-row class="algincenter bgc-blue pad20">
      <el-row type="flex" justify="space-between" style="width:90%;">
        <div>
          <el-row class="height50">
            <span class="fc-wt ft-size24 bold">软件业务</span>
          </el-row>
          <el-row class="hei40">
            <span class="fc-wt ft-size16 pointer">路面养护科学决策辅助系统</span>
          </el-row>
          <el-row class="hei40">
            <span class="fc-wt ft-size16 pointer">桥梁养护科学决策系统</span>
          </el-row>
          <el-row class="hei40">
            <span class="fc-wt ft-size16 pointer">隧道养护科学决策系统</span>
          </el-row>
          <el-row class="hei40">
            <span class="fc-wt ft-size16 pointer">智慧公路管控云平台</span>
          </el-row>
          <el-row class="hei40">
            <span class="fc-wt ft-size16 pointer">路面技术状况智能管理系统</span>
          </el-row>
          <el-row class="hei40">
            <span class="fc-wt ft-size16 pointer">桥梁定期检测系统</span>
          </el-row>
          <el-row class="hei40">
            <span class="fc-wt ft-size16 pointer">公路工程材料试验检测系统</span>
          </el-row>
          <el-row class="hei40">
            <span class="fc-wt ft-size16 pointer">路面养护管理系统</span>
          </el-row>
          <el-row class="hei40">
            <span class="fc-wt ft-size16 pointer">桥梁养护管理系统</span>
          </el-row>
        </div>
        <div>
          <el-row class="height50">
            <span class="fc-wt ft-size24 bold">合作案例</span>
          </el-row>
          <el-row class="hei40">
            <span class="fc-wt ft-size16 pointer">国省道路面技术状况检测</span>
          </el-row>
          <el-row class="hei40">
            <span class="fc-wt ft-size16 pointer">桥梁管理软件案例</span>
          </el-row>
          <el-row class="hei40">
            <span class="fc-wt ft-size16 pointer">公路BIM软件案例</span>
          </el-row>          
        </div>
        <div>
          <el-row class="height50">
            <span class="fc-wt ft-size24 bold">关于我们</span>
          </el-row>
          <el-row class="hei40">
            <span class="fc-wt ft-size16 pointer">网站首页</span>
          </el-row>
          <el-row class="hei40">
            <span class="fc-wt ft-size16 pointer">软件业务</span>
          </el-row>
          <el-row class="hei40">
            <span class="fc-wt ft-size16 pointer">企业简介</span>
          </el-row>
          <el-row class="hei40">
            <span class="fc-wt ft-size16 pointer">企业优势</span>
          </el-row>
          <el-row class="hei40">
            <span class="fc-wt ft-size16 pointer">业务合作</span>
          </el-row>
          <el-row class="hei40">
            <span class="fc-wt ft-size16 pointer">新闻资讯</span>
          </el-row>          
        </div>
        <div>
          <el-row class="height50">
            <span class="fc-wt ft-size24 bold">联系我们</span>
          </el-row>
          <el-row class="hei40">
            <span class="fc-wt ft-size16">北京市昌平区北清路1号院8号楼14层</span>
          </el-row>
          <!-- <el-row class="hei40">
            <span class="fc-wt ft-size16 ">邮箱：155396138@qq.com&emsp;2627504375@qq.com</span>
          </el-row> -->
          <el-row class="hei40">
            <span class="fc-wt ft-size16 ">电话：15869194531(乐)</span>
          </el-row>
          <el-row class="hei40">
            <span class="fc-wt ft-size16 pointer">网站：http://www.ylybj.cn</span>
          </el-row>
          <!-- <el-row class="hei40">
            <i class="fc-wt ft-size24 bold">合伙人招募中...15870649858</i>
          </el-row>
          <el-row class="hei40">
            <span class="fc-wt ft-size16 pointer">商务合作：15079173050(乐)</span>
          </el-row>           -->
        </div>
        <div style="padding-top:80px;">
          <el-row class="width100">
            <img class="width100 block" src="../assets/icon/qrcode.png" alt="">
          </el-row>
          <el-row class="text-center hei30">
            <span class="fc-wt ft-size16">微信公众号</span>
          </el-row>
        </div>
      </el-row>
    </el-row>
    <el-row class="text-center bgc-dark" style=" line-height:100px;">
      <span class="fc-wt ft-size16">版权所有：北京养路云&emsp;</span><a href="https://beian.miit.gov.cn" target="_blank" ><span class="fc-wt ft-size16">&emsp;备案号：京ICP备2022025373号</span></a>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "footerbar",
  data() {
    return {
      screenWidth: document.body.clientHeight,
      isIpad: false
    };
  },
  mounted() {
    const that = this;
    (window.onresize = () => {
      return (() => {
        window.screenHeight = document.body.clientHeight;
        that.screenWidth = window.screenHeight;
      })();
    }),
      (this.isIpad = screen.width <= 1100 || screen.height <= 1100);
  },
  methods: {},
  watch: {}
};
</script>




// WEBPACK FOOTER //
// src/components/footerbar.vue